import { Component, Inject, OnInit, ViewChild } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { DxDataGridComponent } from "devextreme-angular";

@Component({
  selector: "app-order-detail",
  templateUrl: "./order.detail.component.html",
  styleUrls: ["./order.detail.component.scss"],
})
export class OrderDetailComponent implements OnInit {
  salesOrderData: any;
  @ViewChild("grid")
  grid: DxDataGridComponent;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<OrderDetailComponent>
  ) {
    
    this.salesOrderData = data;
    setTimeout(() => {
      this.grid.instance.refresh()
    }, 10);
    console.log("salesOrderData data", data);
  }

  ngOnInit() {
  }

   /**
   * @name customizeText
   * @param e 
   * @description display summary text
   * @returns void
  */
    customizeTextOrders (e) {
      return "Total Orders: ";
    }
  
    /**
     * @name customizeText
     * @param e 
     * @description display summary text
     * @returns void
    */
    customizeText (e) {
      return "Total: ";
    }
    /**
   * @name customizeTotal
   * @param form 
   * @description display summary total
   * @returns void
  */
  customizeTotal (e) {
    console.log(e)
    return e.value;
  }
}
